import { fileManagementApi } from "features/data-management/files/fileManagementApi"
import { key } from "../VideoColorFinder/useColorFinderProcessing"
import { compress } from "plugins/shared/compression"

const uploadAnomalyData = async (
    anomalyData: Uint8Array,
    {
        workspaceId,
        flightId,
        projectId,
    }: { workspaceId: string; projectId: string; flightId: string }
) => {
    const path = key(workspaceId, projectId, flightId, "anomalyIndex.bin")
    try {
        const compressed = await compress(anomalyData, "gzip")
        await fileManagementApi.putFile(compressed, { target: path })
    } catch (err) {
        console.error(`Failed to upload tile ${path}:`, err)
    }

    return path
}

const uploadColorData = async (
    colorData: Uint32Array,
    {
        workspaceId,
        flightId,
        projectId,
    }: { workspaceId: string; flightId: string; projectId: string }
) => {
    const uint8 = new Uint8Array(colorData.buffer, colorData.byteOffset, colorData.byteLength)
    const compressed = new Uint8Array(await compress(uint8, "gzip"))

    const path = key(workspaceId, projectId, flightId, "colorData.bin")

    try {
        await fileManagementApi.putFile(compressed, { target: path })
    } catch (err) {
        console.error(`Failed to upload color data`, err)
    }
    return path
}

export { uploadAnomalyData, uploadColorData }
